import { Subject } from "rxjs";

export const breadcrumbListener = new Subject<(string | JSX.Element)[]>();
